// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
li[data-v-52fb8429] {
    display: inline-block;
    padding: 0 0.5em;
    border: 1px solid var(--color-border-dark);
    border-radius: var(--border-radius-pill);
    margin-right: 0.3em;
    margin-bottom: 0.3em;

    /* prevent text selection - doesn't look good */
    user-select: none; /* Standard */
}
li .count[data-v-52fb8429] {
    margin-left: 0.35em;
    color: var(--color-text-light);
    font-size: 0.8em;
}
.active li[data-v-52fb8429] {
    background-color: var(--color-primary);
    color: var(--color-primary-text);
}
.active li .count[data-v-52fb8429] {
    color: var(--color-primary-text);
}
.disabled li[data-v-52fb8429] {
    border-color: var(--color-border);
    background-color: #fff;
    color: var(--color-border);
}
.disabled li .count[data-v-52fb8429] {
    color: var(--color-border);
}
li[data-v-52fb8429]:hover,
.active li[data-v-52fb8429]:hover {
    border: 1px solid var(--color-primary);
}
.disabled li[data-v-52fb8429]:hover {
    border-color: var(--color-border);
    cursor: default;
}
.disabled[data-v-52fb8429] :hover {
    cursor: default;
}
`, "",{"version":3,"sources":["webpack://./src/components/RecipeKeyword.vue"],"names":[],"mappings":";AA4CA;IACA,qBAAA;IACA,gBAAA;IACA,0CAAA;IACA,wCAAA;IACA,mBAAA;IACA,oBAAA;;IAEA,+CAAA;IACA,iBAAA,EAAA,aAAA;AACA;AAEA;IACA,mBAAA;IACA,8BAAA;IACA,gBAAA;AACA;AAEA;IACA,sCAAA;IACA,gCAAA;AACA;AAEA;IACA,gCAAA;AACA;AAEA;IACA,iCAAA;IACA,sBAAA;IACA,0BAAA;AACA;AAEA;IACA,0BAAA;AACA;AAEA;;IAEA,sCAAA;AACA;AAEA;IACA,iCAAA;IACA,eAAA;AACA;AAEA;IACA,eAAA;AACA","sourcesContent":["<template>\n    <a ref=\"link\" @click=\"clicked\">\n        <li>\n            <span>{{ name }}</span>\n            <span v-if=\"count != null\" class=\"count\">({{ count }})</span>\n        </li>\n    </a>\n</template>\n\n<script setup>\nimport { ref } from 'vue';\n\nconst emit = defineEmits(['keyword-clicked']);\n\ndefineProps({\n    name: {\n        type: String,\n        required: true,\n    },\n    count: {\n        type: Number,\n        default: null,\n    },\n});\n\n/**\n * @type {import('vue').Ref<HTMLElement | null>}\n */\nconst link = ref(null);\n\nconst clicked = () => {\n    if (!link.value.classList.contains('disabled')) {\n        emit('keyword-clicked');\n    }\n};\n</script>\n\n<script>\nexport default {\n    name: 'RecipeKeyword',\n};\n</script>\n\n<style scoped>\nli {\n    display: inline-block;\n    padding: 0 0.5em;\n    border: 1px solid var(--color-border-dark);\n    border-radius: var(--border-radius-pill);\n    margin-right: 0.3em;\n    margin-bottom: 0.3em;\n\n    /* prevent text selection - doesn't look good */\n    user-select: none; /* Standard */\n}\n\nli .count {\n    margin-left: 0.35em;\n    color: var(--color-text-light);\n    font-size: 0.8em;\n}\n\n.active li {\n    background-color: var(--color-primary);\n    color: var(--color-primary-text);\n}\n\n.active li .count {\n    color: var(--color-primary-text);\n}\n\n.disabled li {\n    border-color: var(--color-border);\n    background-color: #fff;\n    color: var(--color-border);\n}\n\n.disabled li .count {\n    color: var(--color-border);\n}\n\nli:hover,\n.active li:hover {\n    border: 1px solid var(--color-primary);\n}\n\n.disabled li:hover {\n    border-color: var(--color-border);\n    cursor: default;\n}\n\n.disabled :hover {\n    cursor: default;\n}\n</style>\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
